export default "__VITE_ASSET__DLv_idHA__"